import { useUrl } from '@/hooks/use-url';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function TplExamplesValueProposalFooter({ site }: { site: any }) {
  const { getAppUrl } = useUrl();
  const router = useRouter();

  if (!site) return <></>;

  return (
    <section className="value-proposal-footer centered ux-spec examples">
      <div className="section-inner">
        <div className="content-inner">
          <p className="title">{site.tpl_examples_value_proposal_footer.title}</p>
          <p className="subtitle">{site.tpl_examples_value_proposal_footer.subtitle}</p>
          <Link href={getAppUrl(`/create/resume?ref=${router.asPath}`)}>
            <button className="cta">
              <span className="cta-text">{site.tpl_examples_value_proposal_footer.cta}</span>
              <img alt="arrow right" src="/assets/icons/arrow-right-white.svg" width="22" height="22" loading="lazy" />
            </button>
          </Link>
        </div>
        <div className="image">
          {site.tpl_examples_value_proposal_footer.image &&
            site.tpl_examples_value_proposal_footer.image.url &&
            site.tpl_examples_value_proposal_footer.image.width &&
            site.tpl_examples_value_proposal_footer.image.height && (
              <img
                alt={site.tpl_examples_value_proposal_footer.image.alt}
                src={site.tpl_examples_value_proposal_footer.image.url}
                width={site.tpl_examples_value_proposal_footer.image.width / 2}
                height={site.tpl_examples_value_proposal_footer.image.height / 2}
                loading="lazy"
              />
            )}
        </div>
      </div>
    </section>
  );
}
